import { useEffect } from "react"
import { Link } from "react-router-dom"
import { feederLegalContent } from "./feederLegalContent"
import "./feederLegal.css"

const nonEmptyLines = (lines) => (Array.isArray(lines) ? lines : []).filter((line) => String(line || "").trim())

export function FeederLegalFooter({ compact = false }) {
  return (
    <footer className={`feeder-legal-footer${compact ? " compact" : ""}`}>
      <span>© FEEDER · feeder.at</span>
      <a href="/impressum">Impressum</a>
    </footer>
  )
}

export default function FeederImpressum({ content = feederLegalContent }) {
  const published = content.publicationStatus === "approved"

  useEffect(() => {
    const previousTitle = document.title
    document.title = "Impressum · FEEDER"
    return () => { document.title = previousTitle }
  }, [])

  return (
    <main className="feeder-legal-shell">
      <article className="feeder-legal-document">
        <header>
          <Link className="feeder-legal-brand" to="/" aria-label="FEEDER Startseite">
            <span>F</span>
            <strong>FEEDER</strong>
          </Link>
          <p>feeder.at</p>
          <h1>{content.title || "Impressum"}</h1>
          {content.introduction && <p className="feeder-legal-introduction">{content.introduction}</p>}
        </header>

        {!published && (
          <section className="feeder-legal-pending" role="status">
            <h2>Inhalt in Prüfung</h2>
            <p>Die bestätigten Betreiberangaben werden aus der freigegebenen Impressumsquelle übernommen.</p>
          </section>
        )}

        {published && (content.sections || []).map((section) => {
          const lines = nonEmptyLines(section.lines)
          if (!section.heading && !lines.length) return null
          return (
            <section key={section.id || section.heading}>
              {section.heading && <h2>{section.heading}</h2>}
              {lines.map((line, index) => <p key={`${section.id || section.heading}-${index}`}>{line}</p>)}
            </section>
          )
        })}

        {published && content.uid && (
          <section>
            <h2>Umsatzsteuer-Identifikationsnummer</h2>
            <p>{content.uid}</p>
          </section>
        )}

        <nav className="feeder-legal-back" aria-label="Seitennavigation">
          <Link to="/">Zurück zu FEEDER</Link>
        </nav>
      </article>
    </main>
  )
}
